import flattenDeep from "lodash/flattenDeep";
import cloneDeep from "lodash/cloneDeep";
export var SortType;
(function (SortType) {
    SortType[SortType["ByCart"] = 0] = "ByCart";
    SortType[SortType["ByCategory"] = 1] = "ByCategory";
})(SortType || (SortType = {}));
export function sortItems(menus, orderMenus, sortType = SortType.ByCart) {
    let sortedOrderMenus = [];
    const orderMenusClone = cloneDeep(orderMenus);
    switch (sortType) {
        default:
        case SortType.ByCart:
            sortedOrderMenus = orderMenusClone;
            break;
        case SortType.ByCategory:
            const modelMenus = getMenuItems(menus);
            modelMenus.forEach((modelMenu) => {
                Object.keys(orderMenusClone).forEach((menu) => {
                    if (orderMenusClone[menu]._id === modelMenu || orderMenusClone[menu].type === 'open_item') {
                        sortedOrderMenus.push(orderMenusClone[menu]);
                        delete orderMenusClone[menu];
                    }
                });
            });
            break;
    }
    return sortedOrderMenus;
}
const getMenuItems = (menus) => {
    return flattenDeep(menus.map((menu) => {
        return menu.categories.map((category) => {
            return category.dishes.map((dish) => {
                return dish._id;
            });
        });
    }));
};
//# sourceMappingURL=index.js.map